module.exports = __webpack_public_path__ + "static/img/video7.80d9618e.png";